import axios from 'axios';
import AxiosWrapper from './AxiosWrapper';
import {
  appendServiceNameToURL,
  appendServicePortToURL,
} from '../resources/serviceURLs';

let isAlertShown = false; // Flag to ensure the alert is shown once per session expiry event

export const handleSessionExpired = () => {
  if (!isAlertShown && window.location.pathname !== '/') {
    isAlertShown = true;
    try {
      localStorage.removeItem('authToken');
      localStorage.removeItem('userRolesToken');
      localStorage.removeItem('userPermissions');
      localStorage.removeItem('activeMenuItem');
      localStorage.removeItem('activeSubmenuItem');
      localStorage.removeItem('activeSubmenuOption');
    } catch (error) {
      console.error('Error clearing storage on session expiry:', error);
    }
    alert('Please re-login, session is expired!');
    window.location.href = '/';
  }
};

if (typeof window !== 'undefined') {
  window.handleSessionExpired = handleSessionExpired;
}

// Global interceptor for direct axios calls
axios.interceptors.response.use(
  (response) => {
    if (
      response?.status === 401
      || response?.data?.status === 401
      || response?.data?.statusCode === 401
      || response?.data?.response?.status === 401
    ) {
      handleSessionExpired();
    }
    return response;
  },
  (err) => {
    if (
      err.response?.status === 401
      || err?.status === 401
      || err?.response?.data?.status === 401
      || err?.response?.data?.statusCode === 401
    ) {
      handleSessionExpired();
    }
    return Promise.reject(err instanceof Error ? err : new Error(err));
  },
);

const UseAxios = async (request, setLoading = () => {}) => {
  setLoading(true); // Set setLoading to true

  if (isAlertShown) {
    handleSessionExpired();
    return Promise.reject(new Error('Please re-login, session is expired!'));
  }

  const { service, method, url, payload, tag, headers, timeout } = request;
  let serviceURL = appendServiceNameToURL(service);
  const servicePort = appendServicePortToURL(service);

  if (process.env.NODE_ENV === 'production') {
    serviceURL = process.env.REACT_APP_API_URL + serviceURL + '/api' + url;
  } else {
    serviceURL
      = process.env.REACT_APP_API_URL + `:${servicePort}` + serviceURL + '/api' + url;
  }

  const Wrapper = new AxiosWrapper(serviceURL, 'your-username', 'your-password', setLoading);
  const instance = Wrapper.axiosInstance;
  const authToken = Wrapper.getAuthToken();

  headers.token = headers?.isAuthToken ? headers.token : authToken;

  // **Fix for FormData**
  const isFormData = payload instanceof FormData;
  if (isFormData) {
    delete headers['Content-Type']; // Let Axios set it automatically
  }

  let axiosRequest = null;
  const axiosConfig = { headers: headers, timeout: timeout || 180000 }; // Set default timeout to 60 seconds

  switch (method) {
  case 'get':
    axiosRequest = instance.get(serviceURL, axiosConfig);
    break;
  case 'post':
    axiosRequest = instance.post(serviceURL, payload, axiosConfig);
    break;
  case 'put':
    axiosRequest = instance.put(serviceURL, payload, axiosConfig);
    break;
  case 'delete':
    axiosRequest = instance.delete(serviceURL, { ...axiosConfig, data: payload }); // Include payload in DELETE request
    break;
  case 'patch':
    axiosRequest = instance.patch(serviceURL, payload, axiosConfig);
    break;
  default:
    throw new Error(`Unsupported method: ${method}`);
  }

  return axiosRequest
    .then((response) => {
      if (
        response?.status === 401
        || response?.data?.status === 401
        || response?.data?.statusCode === 401
        || response?.data?.response?.status === 401
      ) {
        handleSessionExpired();
        return Promise.reject(new Error('Please re-login, session is expired!'));
      }
      return { tag, data: response.data, status: response?.status };
    })
    .catch((err) => {
      if (
        err.response?.status === 401
        || err?.status === 401
        || err?.response?.data?.status === 401
        || err?.response?.data?.statusCode === 401
      ) {
        handleSessionExpired();
        return Promise.reject(new Error('Please re-login, session is expired!'));
      } else {
        return { tag, data: err };
      }
    });
};

export default UseAxios;

